import React from 'react';
import { map, each } from 'underscore';

import { AdPlacementsGroupType } from '@bingads-webui-campaign-react/ad-placement-consts';

import { GroupTypeTemplatesMapping } from '..';

export const staticTemplateProperties = [
  'aspectRatio',
  'type',
  'associationType',
  'isRequired',
  'minimumRequirements',
  'minSize',
  'maxSize',
];

const getAllAssociationTypesForAdType = (adType) => {
  const templates = GroupTypeTemplatesMapping[adType];

  return map(templates, ({ associationType }) => associationType);
};

const getImageTypeForTemplate = template => template.associationType;

const getTemplateTypeForTemplate = template => template.type;

const doesTemplateShowImage = template => template.previewSettings.showImage;

const doesTemplateHideHeaderButtons = template => template.hideHeaderButtons;

const getCarouselTitleForTemplate = (template, groupType, i18n) => {
  const { localizedText, previewSettings } = template;
  let title;

  const aspectRatio = i18n.getString(localizedText.stringKey);
  const titleTemplate = i18n.getString(_TL_('Ad preview ({{aspectRatio}} aspect ratio)'), { aspectRatio });

  switch (groupType) {
    case AdPlacementsGroupType.imageExtension:
    case AdPlacementsGroupType.searchImageAd:
    case AdPlacementsGroupType.streamlinedSignup:
      if (previewSettings.showImage) {
        title = (
          <span className="preview-title-string-key">{titleTemplate}</span>
        );
      } else {
        title = null;
      }
      break;
    case AdPlacementsGroupType.msanImageAd:
      if (aspectRatio) {
        title = (
          <span className="preview-title-string-key">{titleTemplate}</span>
        );
      } else {
        title = (
          <span className="preview-title-string-key">{i18n.getString(localizedText.previewTypeStringKey)}</span>
        );
      }
      break;
    case AdPlacementsGroupType.perfMax:
      title = (
        <React.Fragment>
          <span className="preview-title-string-key">{i18n.getString(localizedText.stringKey)}</span>
          <span
            className="preview-title-preview-type"
            title={i18n.getString(localizedText.previewTypeStringKey)}
          >
            {i18n.getString(localizedText.previewTypeStringKey)}
          </span>
        </React.Fragment>);
      break;
    case AdPlacementsGroupType.appAd:
    case AdPlacementsGroupType.appAdStart:
      title = (
        <span className="preview-title-string-key">{i18n.getString(localizedText.previewTypeStringKey)}</span>
      );
      break;
    case AdPlacementsGroupType.responsiveSearchAd:
    case AdPlacementsGroupType.dynamicSearchAd:
      title = null;
      break;
    default:
      title = i18n.getString(_TL_('Ad preview'));
      break;
  }

  return title;
};
const getMinSizeForTemplate = ({ minSize = [] } = {}) => ({
  minWidth: minSize[0],
  minHeight: minSize[1],
});
const validateImageSizeForTemplate = (template, image) => {
  const { minWidth = 0, minHeight = 0 } = getMinSizeForTemplate(template);

  if (image) {
    const widthToCheck = (image.BaseImage && image.BaseImage.CropSettings && image.BaseImage.CropSettings.SourceWidth) || image.Width;
    const heightToCheck = (image.BaseImage && image.BaseImage.CropSettings && image.BaseImage.CropSettings.SourceHeight) || image.Height;

    return (widthToCheck >= minWidth) && (heightToCheck >= minHeight);
  }
  return false;
};

const getCropSettingsInfoFromTemplates = (templates) => {
  const cropSettingsInfo = [];

  each(templates, (template) => {
    const {
      aspectRatio,
      type,
      associationType,
      minSize,
    } = template;
    cropSettingsInfo.push({
      aspectRatio,
      type,
      associationType,
      minSize,
    });
  });

  return cropSettingsInfo;
};

const getIsRequiredFromTemplate = ({ isRequired }) => isRequired;


export const templateParserUtils = {
  getImageTypeForTemplate,
  getCarouselTitleForTemplate,
  getMinSizeForTemplate,
  validateImageSizeForTemplate,
  getCropSettingsInfoFromTemplates,
  getAllAssociationTypesForAdType,
  getTemplateTypeForTemplate,
  getIsRequiredFromTemplate,
  doesTemplateShowImage,
  doesTemplateHideHeaderButtons,
};
